import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityFormMode } from '@/common/entityFramework/enumerations/EntityFormMode';
import { useForm } from '@/common/form/FormContext';
import { EntitySelect } from '@/common/form/formFields/EntitySelect';
import { useEffect, useMemo } from 'react';

export const CtrtOwnerCust = ({ fieldDef }) => {

    const { formValues, assignValue } = useForm();
    const { entityFormMode } = useEntityMgr();
    
    const ctrtTypeNoOwner = ['MCD', 'MPD']; 

    useEffect(() => {
      if (ctrtTypeNoOwner.includes(formValues.type)) {
        assignValue('ownerCustId', null);
        assignValue('ownerCustCode', null);
      }
    }, [formValues.type]);

    const updatedFieldDef = useMemo(() => {
      return {
        ...fieldDef,
        disabled: ctrtTypeNoOwner.includes(formValues.type) || entityFormMode !== EntityFormMode.ADD,
        required: !ctrtTypeNoOwner.includes(formValues.type)
      };
    }, [formValues.type]);

  return <EntitySelect fieldDef={updatedFieldDef} />;
}